import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LuciToolbarComponent } from './luci-toolbar.component';
import { FormsModule } from '@angular/forms';
import { LuciSearchModule } from '../luci-search/luci-search.module';
import { LuciButtonModule } from '../luci-button/luci-button.module';
import { LuciDropdownModule } from '../luci-dropdown/luci-dropdown.module'
import { ExportModule } from '../commons/services/export/export.module';



@NgModule({
    declarations: [LuciToolbarComponent],
    exports: [LuciToolbarComponent],
    imports: [
        CommonModule,
        FormsModule,
        LuciSearchModule,
        LuciButtonModule,
        ExportModule,
        LuciDropdownModule
    ]
})
export class LuciToolbarModule { }
